/**
 * @generated SignedSource<<52cd90e18f3cff54226fdcbb8aace882>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InitiateInvoicePaymentDialog_invoice$data = {
  readonly id: string;
  readonly invoiceNumber: string | null | undefined;
  readonly paymentMethod: {
    readonly cardBrand: string | null | undefined;
    readonly lastFourDigits: string | null | undefined;
    readonly paymentMethodType: string;
  };
  readonly sentAt: any | null | undefined;
  readonly " $fragmentType": "InitiateInvoicePaymentDialog_invoice";
};
export type InitiateInvoicePaymentDialog_invoice$key = {
  readonly " $data"?: InitiateInvoicePaymentDialog_invoice$data;
  readonly " $fragmentSpreads": FragmentRefs<"InitiateInvoicePaymentDialog_invoice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InitiateInvoicePaymentDialog_invoice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentMethod",
      "kind": "LinkedField",
      "name": "paymentMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentMethodType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardBrand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFourDigits",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    }
  ],
  "type": "Invoice",
  "abstractKey": null
};

(node as any).hash = "537c9008aa09cd1627276373f178efb4";

export default node;
